import React, {useState} from "react";
import {addYears} from "date-fns";
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import useRequestData from "../../../hooks/useRequestData";
import {PageHeader} from "../../../components/PageHeader";
import {getDisposeAssetList} from "../../../api/lifecycle/dispose/DisposeService";
import DisposeAssetListType from "./subPages/DisposeAssetListType";

function DisposeAssetList() {

    const [checked, setChecked] = useState([]);

    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    }

    const {newData, pageInfo, dataHook} = useRequestData(getDisposeAssetList, initDate, "dispose_asset");

    return (
        <>
            <div className="common-container">
                <PageHeader header={"폐기자산관리"} indicator={"라이프사이클 > 자산폐기관리 > 폐기자산관리"}/>
                <DisposeAssetListType
                    data={newData} dataHook={dataHook}
                    date={initDate} pageInfo={pageInfo}
                    checked={{checked: checked, setChecked: setChecked}}/>
            </div>
        </>
    );
}

export {DisposeAssetList};